
<script>
    export let label;
    export let required = false;
    export let hasError = null;
    export let requiredError = null;
</script>

<style>
    label {
        line-height: 1;
    }
    label .error {
        color: var(--order-error-label-color);
    }
</style>

<label>
    { label }
    {#if (required)}
        {#if (hasError)}<span class="error">{ requiredError }</span>{:else}*{/if}
    {/if}
</label>
